import { render, staticRenderFns } from "./PriorityEdit.vue?vue&type=template&id=27d0e590&"
import script from "./PriorityEdit.vue?vue&type=script&lang=js&"
export * from "./PriorityEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports